import styled from 'styled-components'
import { Row } from 'react-bootstrap'
import { theme } from './../../common'

export const StyledCardContainer = styled(Row)`
    border-top: 3px solid ${theme.primary};
    background-color: ${theme.lightGrey};
    padding: 5% 10%;
    height: 100%;
`

export const StyledTitle = styled.h2`
    font-size: 2em;
    font-weight: bold;
    text-transform: uppercase;
`

export const StyledImage = styled.img`
    max-width: 170px;
    width: 100%;
    height: auto;
    margin-bottom: 5%;
`